import { MegamenuItem, NavItemType } from "shared/Navigation/NavigationItem";
import ncNanoId from "utils/ncNanoId";
import __megamenu from "./jsons/__megamenu.json";
import supabase from "utils/supabaseClient";
export interface curatedType {
  id?:number;
  name?: string;
  href?: string;
  count?: number;
  created_at?: Date;
}
let curated_hotels: NavItemType[] = []
let curate_estate: NavItemType[] = []

const getCurateHotel = async () =>{
  
  let { data, error } = await supabase
  .from("curate-hotels")
  .select("id,name,href")
  if(data){
    curated_hotels = data;
  }else{console.log(error?.message)}
}

const getCurateEstate =async () => {
  let { data, error } = await supabase
  .from("curate-estate")
  .select("id,name,href")
  if(data){
    curate_estate = data;
  }else{console.log(error?.message)}
}

getCurateHotel()
getCurateEstate()



const megaMenuDemo: MegamenuItem[] = [
  {
    id: ncNanoId(),
    image:
      "https://hamrhjkkdekizaifnvmj.supabase.co/storage/v1/object/public/images/small-hotel-bedroom-with-white-walls-panoramic-window.jpg?t=2022-11-29T22%3A02%3A48.835Z",
    title: "Hotels",
    items: curated_hotels.map((i) => ({
      id: i.id,
      href: "#",
      name: i.name,
    })),
  },
  {
    id: ncNanoId(),
    image:
      "https://hamrhjkkdekizaifnvmj.supabase.co/storage/v1/object/public/images/webaliser-_TPTXZd9mOo-unsplash.jpg",
    title: "Real estate",
    items: curate_estate.map((i) => ({
      id: i.id,
      href: "#",
      name: i.name,
    })),
  },
];

console.log(megaMenuDemo)


export const NAVIGATION_DEMO: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/",
    name: "Home",
  },
  {
    id: ncNanoId(),
    href: "/listing-stay",
    name: "Hotels",
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/listing-real-estate",
    name: "Apartments (Houses)",
    isNew: true,
  },
  
];

export const NAVIGATION_MOBILE: NavItemType[] = [
  {
    id: ncNanoId(),
    href: "/",
    name: "Home",
  },
  {
    id: ncNanoId(),
    href: "/listing-stay",
    name: "Hotels",
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/listing-real-estate",
    name: "Apartments (Houses)",
    isNew: true,
  },
  {
    id: ncNanoId(),
    href: "/login",
    name: "Login",
  },
  {
    id: ncNanoId(),
    href: "/signup",
    name: "Signup",
  },
];
